// ============================================================
// C1：渲染预设工具（命令构建 / 当前设置捕获 / 对比直应用）
// 应用走 E0 命令总线事务（可撤销）；对比为临时直应用（不写历史）
// ============================================================
import type { CommandSpec } from '../core/commandBus';
import useSceneStore from '../stores/sceneStore';
import type { RenderPresetSettings } from '../api/renderPresets';

/** 预设设置 → 命令总线命令（environment/effects 各一条；lights 预留） */
export function buildPresetCommands(settings: RenderPresetSettings): CommandSpec[] {
  const cmds: CommandSpec[] = [];
  if (settings.environment && Object.keys(settings.environment).length > 0) {
    cmds.push({ type: 'scene.environment.set', payload: { patch: settings.environment } });
  }
  if (settings.effects && Object.keys(settings.effects).length > 0) {
    cmds.push({ type: 'scene.effects.set', payload: { patch: settings.effects } });
  }
  return cmds;
}

/** 捕获当前渲染设置（保存自定义预设 / 对比基线用；深拷贝） */
export function captureCurrentPresetSettings(): RenderPresetSettings {
  const s = useSceneStore.getState();
  return {
    environment: { ...s.environment },
    effects: JSON.parse(JSON.stringify(s.effects)) as Record<string, unknown>,
  };
}

/** 对比：临时直应用（不产生撤销步） */
export function applyPresetDirect(settings: RenderPresetSettings): void {
  const s = useSceneStore.getState();
  if (settings.environment) s.setEnvironment(settings.environment as never);
  if (settings.effects) s.setEffects(settings.effects as never);
}
